"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignupCtrl = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var modal_service_1 = require("../../components/modal/modal.service");
var notification_service_1 = require("../../components/notification.toast/notification.service");
var index_1 = require("../../i18n/index");
var page_1 = require("../../page/page");
var services_1 = require("../../services");
var user_service_1 = require("../../services/user.service");
var SignupCtrl = /** @class */ (function () {
    function SignupCtrl(success) {
        this.loading = false;
        this.invalidEmail = null;
        this.success = success;
    }
    SignupCtrl.prototype.signupSSO = function (inviteToken, firstname, lastname) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, e_1, result;
            var _b, _c, _d, _e;
            return tslib_1.__generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        this.setLoading(true);
                        _f.label = 1;
                    case 1:
                        _f.trys.push([1, 3, 7, 8]);
                        _a = this.success;
                        return [4 /*yield*/, user_service_1.UserMutator.createSSO(inviteToken, firstname, lastname)];
                    case 2:
                        _a.apply(this, [_f.sent()]);
                        return [3 /*break*/, 8];
                    case 3:
                        e_1 = _f.sent();
                        if (!(((_c = (_b = e_1.errors) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.field) === 'email' && ((_e = (_d = e_1.errors) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.codes) === 'already_exists')) return [3 /*break*/, 5];
                        modal_service_1.ModalService.close();
                        return [4 /*yield*/, modal_service_1.ModalService.open({
                                title: (0, index_1.Translate)(index_1.T.USER_ALREADY_EXISTS),
                                content: (0, index_1.Translate)(index_1.T.USER_ALREADY_EXISTS_DESCRIPTION),
                                hasCancel: false,
                                okName: index_1.T.LOGIN
                            })];
                    case 4:
                        result = _f.sent();
                        if (result.ok) {
                            services_1.Services.SSO.login({
                                redirect_uri: window.location.origin + services_1.Services.Route.getRouteURL(page_1.IkePageName.acceptInvite, { inviteToken: inviteToken })
                            });
                        }
                        return [3 /*break*/, 6];
                    case 5:
                        notification_service_1.NotificationService.error({ key: index_1.T.ERROR_GENERAL });
                        _f.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        this.setLoading(false);
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    SignupCtrl.prototype.setLoading = function (loading) {
        this.loading = loading;
    };
    SignupCtrl.prototype.setInvalidEmail = function (invalidEmail) {
        this.invalidEmail = invalidEmail;
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], SignupCtrl.prototype, "loading", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SignupCtrl.prototype, "invalidEmail", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], SignupCtrl.prototype, "setLoading", null);
    tslib_1.__decorate([
        mobx_1.action
    ], SignupCtrl.prototype, "setInvalidEmail", null);
    return SignupCtrl;
}());
exports.SignupCtrl = SignupCtrl;
//# sourceMappingURL=signup.ctrl.js.map